import { Topbar } from '@xprog/prensa'
import ClickableAsset from 'components/ClickableAsset/ClickableAsset.index'
import TopbarItems from 'components/Topbar/Items/TopbarItems.index'
import { TopbarMobileProps } from 'components/Topbar/Mobile/TopbarMobile.types'
import React from 'react'

const TopbarMobile: React.FC<TopbarMobileProps> = (props) => {

  const RenderTopbarItems = () => {
    return (
      <TopbarItems
        css={props?.css?.topbarItems}
        hideInMobile={false}
        items={props?.menuTopItems}
      />
    )
  }

  const RenderTopbarLogo = () => {
    const selectedLogo = props.logos.find((i) => i.name === props.mainLogo) || {}
    return (
      <ClickableAsset
        alt='Ir para a Home | Atualizar a página'
        src={selectedLogo.url}
        hasH1={true}
        href='/'
        height={selectedLogo.height}
        id='pop-logo'
        width={selectedLogo.width}
      />
    )
  }

  const SlotTopLeft = props.slotTopLeft || null
  const SlotTopCenter = props.slotTopCenter || null
  const SlotTopRight = props.slotTopRight || null
  const SlotMiddleLeft = props.slotMiddleLeft || null
  const SlotMiddleRight = props.slotMiddleRight || null
  const SlotBottomLeft = props.slotBottomLeft || null
  const SlotBottomCenter = <RenderTopbarItems />
  const SlotBottomRight = props.slotBottomRight || null

  return (
    <Topbar
      css={{ ...props?.css, cssContainer: { ...props?.css?.cssContainer, '@lg': { display: 'none' } } }}
      slotTopLeft={SlotTopLeft}
      slotTopCenter={SlotTopCenter}
      slotTopRight={SlotTopRight}
      slotMiddleLeft={SlotMiddleLeft}
      slotMiddleCenter={RenderTopbarLogo}
      slotMiddleRight={SlotMiddleRight}
      slotBottomLeft={SlotBottomLeft}
      slotBottomCenter={SlotBottomCenter}
      slotBottomRight={SlotBottomRight}
    />
  )
}

export default TopbarMobile